import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemInvitationComponent } from '../../components/item-invitation/item-invitation.component';
import { ItemInvitationDependentComponent } from '../../components/item-invitation-dependent/item-invitation-dependent.component';
import { CardDependentsComponent } from '../../components/card-dependents/card-dependents.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';
import { PanelDirective } from '../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'dependents',
	templateUrl: './dependents.component.html',
	imports: [
		CommonModule, PanelDirective, TranslatePipe, ItemInvitationComponent, 
		ItemInvitationDependentComponent, CardDependentsComponent, FormsModule
	]
})
export default class DependentsView implements OnInit {
	private session: Session = inject(Session);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('employees').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.invitationInfo = this.angularFilterHelperService.translate('Dependents.Invite_As_Business_Owner');
		this.vm.isInviteEnabled = this.vm.user.service.walletType === 'EMPLOYER';
		
		this.vm.handleInvitationOpen = this.handleInvitationOpen;
		this.vm.handleInvitationClose = this.handleInvitationClose;
	}
	
	handleInvitationOpen(invitationType) {
		var allowedTypes: Array<any> = ['form', 'integration'];
		if (allowedTypes.indexOf(invitationType) === -1) return;
		this.vm.isInvitationOpen = true;
		this.vm.invitationType = invitationType;
	}
	
	handleInvitationClose() {
		this.vm.isInvitationOpen = false;
	}
	
}